import { render, staticRenderFns } from "./darwing.vue?vue&type=template&id=0b4185f2&scoped=true&"
import script from "./darwing.vue?vue&type=script&lang=js&"
export * from "./darwing.vue?vue&type=script&lang=js&"
import style0 from "./darwing.vue?vue&type=style&index=0&id=0b4185f2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4185f2",
  null
  
)

export default component.exports